import React from "react";
import { toast } from "react-toastify";
import { AlertTriangle } from "lucide-react";

const ToastInfo = (heading: string, messages: string[] | string) => {
  toast(
    <div style={{ width: 380 }}>
      <div
        style={{ fontSize: "14px", background: "#FEF6DB", color: "#F59E0B" }}
        className="d-flex align-items-center gap-2 px-2 py-1"
      >
        <AlertTriangle color="#F59E0B" size={16} />
        <span className="fw-bold">{heading || "Error"}</span>
      </div>
      <div
        style={{
          fontSize: "14px",
          lineHeight: "150%",
          color: "#F59E0B",
          background: "white",
        }}
        className="px-2 py-2"
      >
        {Array.isArray(messages) ? (
          messages.map((msg, i) => <div key={i}>{msg}</div>)
        ) : (
          <div>{messages}</div>
        )}
      </div>
    </div>,
    {
      autoClose: 4000,
      hideProgressBar: true,
    }
  );
};

export default ToastInfo;
